// extracted by mini-css-extract-plugin
module.exports = {"icon":"styles_icon__2V93J","iconDash":"styles_iconDash__7OK3j","spin-dash":"styles_spin-dash__4QBgK","iconLine":"styles_iconLine__h24xV","spin-line":"styles_spin-line__afkWk"};